import { createSlice } from '@reduxjs/toolkit';

const gameSlice = createSlice({
    name: 'game',
    initialState: {
        players: {
            team1: [],
            team2: []
        },
        gameID: null,
    },
    reducers: {
        setPlayers: (state, action) => {
            const { team1Players, team2Players } = action.payload;
            state.players.team1 = team1Players;
            state.players.team2 = team2Players;
        },
        setGameID: (state, action) => {
            state.gameID = action.payload;
        },
        // Add more reducers as needed
    }
});

// Export actions
export const { setPlayers, setGameID } = gameSlice.actions;

// Export the reducer
export default gameSlice.reducer;